import API from '../../../api';

export default class extends API {

    static analytics() {
        return this.get(`analytics/admin`);
    }
}